import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { FeedbackManagement } from '../modal';

export default function reducer(state: FeedbackManagement = new FeedbackManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.FEEDBACK_MGMT_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.FEEDBACK_MGMT_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.FEEDBACK_MGMT_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
